module.exports = __webpack_public_path__ + "img/burger.25e02b18.svg";